export function categoryWorkflow(category) {
  const name = String(category?.name || "").trim().toLowerCase();
  if (name.includes("costume") && name.includes("rental")) return "costume-rentals";
  if (name.includes("machine service")) return "machine-services";
  if (name.includes("tailoring material")) return "materials";
  if (name.includes("dry clean") || name.includes("pressing")) return "dry-cleaning";
  if (name.includes("alteration")) return "alterations";
  if (name === "fabric store" || name.includes("fabric")) return "fabric-store";
  if (name.includes("home measurement")) return "home-measurement";
  return "stitching";
}

export function categoryDestination(category) {
  const workflow = categoryWorkflow(category);
  if (workflow === "stitching") return `/category/${category.id}`;
  if (workflow === "home-measurement") return "/services/home-measurement";
  return `/services/${workflow}`;
}
